import React from "react";
import { ProducerTotalLoaderTemplate } from "themes/application/producer/components";

function ProducerTotalLoader(props) {
    return <ProducerTotalLoaderTemplate {...props} />;
}

export default ProducerTotalLoader;
